module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAYElEQVQ4y2NgGBxg5tb/IDznxuP/Gx+8/A/jg3DT2dv/Ew9cBMshi4MxugGHnr9DUQDSBNMMogkaALINZhPMZmQapwHnBNX+k4PhBvwnEwwiAygOA7mtVv/JwYPIgKENAK6xpZTsfUKSAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/UZ.png
// module id = 1294
// module chunks = 0